// Karthus - Requiem: channels briefly then deals magic damage to ALL enemies globally.
// Hits are staggered with delayMs so beams arrive in sequence across the field.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityContext, AbilityHit } from "./Ability";

const WINDUP_MS = 1000;
const STAGGER_MS = 120;

export const karthusRequiem: Ability = {
  id: "karthusRequiem",
  displayName: "Requiem",
  description: "Channels for 1 second, then deals massive magic damage to all enemies on the field.",
  iconId: "KarthusRequiem",

  targetShape(ctx) {
    const enemies = ctx.combat.livingUnitsOf(
      ctx.caster.team === "player" ? "enemy" : "player",
    );
    return enemies.map((e) => e.pos);
  },

  computeHits(ctx) {
    const enemies = ctx.combat.livingUnitsOf(
      ctx.caster.team === "player" ? "enemy" : "player",
    );
    const stats = effectiveStats(ctx.caster);
    const hits: AbilityHit[] = [];
    enemies.forEach((enemy, i) => {
      const dmg = magicDamage(stats.ap * 1.4 + 90);
      hits.push({
        target: enemy,
        amount: dmg,
        type: "magical",
        requiemBeam: true,
        suppressPopup: true,
        delayMs: WINDUP_MS + i * STAGGER_MS,
      });
    });
    return hits;
  },
};
